import { useChannelStore } from './use-channel-store';

export const useConsumer = () => {
	return useChannelStore((state) => state.consumer);
};
